import { render, staticRenderFns } from "./MaterialGroupEdit.vue?vue&type=template&id=6c83fe73&"
import script from "./MaterialGroupEdit.js?vue&type=script&lang=js&"
export * from "./MaterialGroupEdit.js?vue&type=script&lang=js&"
import style0 from "./MaterialGroupEdit.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports